import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  structuredData?: Record<string, unknown> | Array<Record<string, unknown>>;
}

export function SEO({
  title = "Mi Asistente Legal IA - Tu Asistente Legal Inteligente",
  description = "Plataforma de inteligencia artificial jurídica en Colombia. Automatiza cobranza de cartera PH, control de expedientes judiciales, redacción de tutelas y demandas, calculadoras judiciales y formación clínica.",
  keywords = "asistente legal, inteligencia artificial jurídica Colombia, software para abogados, cartera PH ley 675, control expedientes judiciales, redacción tutelas demandas, calculadoras judiciales CSJ DANE, consultorio juridico ley 2113",
  image = "https://miasistentelegalia.com/assets/og-image.png",
  url,
  type = "website",
  structuredData,
}: SEOProps) {
  const currentUrl =
    url ||
    (typeof window !== "undefined"
      ? window.location.origin + window.location.pathname
      : "https://miasistentelegalia.com");

  const fullImageUrl = image.startsWith("http")
    ? image
    : `https://miasistentelegalia.com${image.startsWith("/") ? image : `/${image}`}`;

  const siteTitle =
    title.includes("Mi Asistente Legal IA") || title.includes("Mi Asistente Legalia")
      ? title
      : `${title} | Mi Asistente Legal IA`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{siteTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Mi Asistente Legal IA" />
      <meta property="og:locale" content="es_CO" />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />

      {/* Additional SEO Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="Spanish" />
      <meta name="author" content="Mi Asistente Legal IA" />

      {/* Structured Data (JSON-LD) */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}

      {/* Favicon */}
      <link rel="icon" type="image/svg+xml" href="/assets/favicon.svg" />
      <link rel="icon" type="image/png" sizes="32x32" href="/assets/logo-icon-32.png" />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/assets/logo-icon-180.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/assets/logo-icon-32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/assets/logo-icon-32.png"
      />
      <link rel="manifest" href="/site.webmanifest" />
    </Helmet>
  );
}
